import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Dashboard from '@/pages/Dashboard/Dashboard';
import { pathMenu } from '@/constants/routeName';

/** Parents land on the family dashboard; legacy student accounts use the menu as home. */
export default function AppLanding() {
	const accountType = useSelector((state) => state.auth.accountType);

	if (accountType === 'legacy') {
		return <Navigate to={pathMenu} replace />;
	}

	return <Dashboard />;
}
